import React from 'react';
import Link from 'gatsby-link';
import format from 'date-fns/format';

import './blog-post-grid-item.scss';

const Preview = ({
  heading,
  imageUrl,
  title,
  author,
  date,
  excerpt,
  category,
  slug,
  variant
}) => {
  const previewImage = (
    <Link to={`/blog/${slug}`}>
      <img
        className="blog-post-grid-time__image"
        src={
          imageUrl +
          '?fm=jpg&q=80&w=400&h=400&fl=progressive&fit=thumb&f=face'
        }
      />
    </Link>
  );

  const previewCopy = (
    <div>
      <div className="blog-post-preview__category blog-tag">
        {category}
      </div>
      <Link className="link--no-decoration" to={`/blog/${slug}`}>
        <div className="blog-post-grid-item__title">
          {title}
        </div>
      </Link>
      <div className="blog-post-grid-item-preview__meta">
        {author} - {format(date, 'MMMM D, YYYY')}
      </div>
    </div>
  );

  return (
    <section className="blog-post-grid-item">
      {previewImage}
      {previewCopy}
    </section>
  );
};

export default Preview;



// WEBPACK FOOTER //
// ./src/components/blog-post-grid-item.js